module.exports = __webpack_public_path__ + "static/media/AB_PW7_3.5ecc48fd.jpg";